import Queue from "pages/queue";

const routes = [
  // Customers
  {
    path: `/queue`,
    exact: true,
    auth: true,
    component: Queue,
  },
];

export default routes;
